<script setup>
import { useResourceListApi, } from '@/assets/js/src/modules/resource/_composables/useResourceListApi'
import { defineAsyncComponent, } from 'vue'
import { useListHeadInfo, } from '@/assets/js/src/modules/resource/_composables/useListHeadInfo'

const ListComponents = {
    'dictionary': defineAsyncComponent(() => import('@/assets/js/src/modules/resource/_views/DictionaryList.vue')),
    'graphic': defineAsyncComponent(() => import('@/assets/js/src/modules/resource/_views/GraphicList.vue')),
    'video': defineAsyncComponent(() => import('@/assets/js/src/modules/resource/_views/VideoList.vue')),
}

const { messagesLoaded,asyncStatus,provider, } = useResourceListApi()
useListHeadInfo({ provider, })
</script>

<template>
    <component
        :is="ListComponents[provider]"
        v-bind="{
            messagesLoaded,
            asyncStatus,
            provider,
        }"
    ></component>
</template>
